<template>
  <!-- <div class="mt-6 pt-6"> -->
  <!-- <Navigation /> -->
  <!-- <HomePage /> -->
  <!-- </div> -->

  <div class="columns is-fullheight" style="min-height: 102vh">
    <div
      class="column is-2 is-sidebar-menu has-background-black-ter has-text-white"
      :class="{ 'is-hidden-mobile': !sidebarState }"
      style="position: relative"
    >
      <div class="has-text-centered my-6 has-text-weight-bold">
        <span class="is-size-5">@</span> CMTY
      </div>
      <aside class="menu">
        <ul class="menu-list">
          <li>
            <RouterLink to="/" class="has-text-white"
              ><i class="ri-wallet-3-fill"></i> Dashboard</RouterLink
            >
          </li>
          <li>
            <RouterLink to="/deposit" class="has-text-white"
              ><i class="ri-safe-2-fill"></i> Deposit</RouterLink
            >
          </li>
          <li>
            <RouterLink to="withdraw" class="has-text-white"
              ><i class="ri-hand-coin-fill"></i> Withdraw</RouterLink
            >
          </li>
<!--
          <li>
            <RouterLink to="/rewards" class="has-text-white"
              ><i class="ri-coin-line"></i> Rewards</RouterLink
            >
          </li>
-->          
          <!-- Admin Options Section -->
          <li v-if="isAdmin || isManager" class="my-3 mt-4">
            <div class="has-text-weight-bold has-background-grey-darker px-2 py-1 has-text-centered">
              Admin Options
            </div>
          </li>
          <li v-if="isAdmin">
            <RouterLink to="asset-classes" class="has-text-white"
              ><i class="ri-folder-settings-fill"></i> Asset Classes</RouterLink
            >
          </li>
          <li v-if="isAdmin">
            <RouterLink to="/token-list" class="has-text-white"
              ><i class="ri-token-swap-line"></i> Edit NFTs</RouterLink
            >
          </li>
<!--
          <li v-if="isManager">
            <RouterLink to="/yield-distribution" class="has-text-white"
              ><i class="ri-coins-line"></i> Yield Distribution</RouterLink
            >
          </li>
-->
          <li v-if="isTreasury" class="my-3 mt-4">
            <div class="has-text-weight-bold has-background-grey-darker px-2 py-1 has-text-centered">
              Treasury Options
            </div>
          </li>
          <li v-if="isTreasury">
            <RouterLink to="/approve-funds" class="has-text-white"
              ><i class="ri-money-dollar-circle-line"></i> Approve Funds</RouterLink
            >
          </li>
        </ul>
      </aside>
      <div class="sidebar-separator"></div>
      <div style="position: absolute; bottom: 0">
        <ul class="pl-5 mb-5">
          <li class="my-2">
            <a class="has-text-grey"><i class="ri-question-line"></i> Help</a>
          </li>
          <li class="my-2">
            <a class="has-text-grey"
              ><i class="ri-mail-send-line"></i> Contact us</a
            >
          </li>
        </ul>
      </div>
    </div>

    <div :class="['column is-main-content px-0', currentTheme === 'dark' ? 'has-background-dark' : 'has-background-light']">
      <nav class="navbar">
        <div class="navbar-brand">
          <a class="navbar-item">
            <img class="ml-5" style="max-height: 4rem" :src="pageLogo" />
          </a>
        </div>

        <div id="navMenubd-example" class="navbar-menu">
          <div class="navbar-start"></div>

          <div class="navbar-end">
            <div class="navbar-item">
              <div class="field is-grouped">
                <p v-if="isConnected" class="control">
                  <a
                    class="button is-ghost is-small"
                  >
                    <span class="has-text-grey has-text-weight-bold"
                      >{{ account.slice(0, 4)+'...'+account.slice(-4) }}
                      </span>
                  </a>
                </p>
                <p v-if="isConnected" class="control">
                  <a
                    @click="disconnect()"
                    class="button is-light is-small"
                  >
                    <span>Disconect</span>
                  </a>
                </p>
                <p class="control">
                  <ThemeToggle />
                </p>
                <p v-if="!isConnected" class="control">
                  <a
                    @click="connect()"
                    class="button is-light is-small"
                  >
                    <span>Connect</span>
                  </a>
                </p>

                <p class="control is-show-mobile mr-3">
                  <a
                    @click="activateSideBar()"
                    class="button is-light is-small"
                  >
                    <i class="ri-menu-line"></i>
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </nav>

      <div class="real-main-content px-6">
        <router-view />
      </div>


    </div>
  </div>
</template>

<script>
import { RouterLink, RouterView } from 'vue'
import pageLogo from "@/assets/cmty-logo.png";
import ThemeToggle from "./components/ThemeToggle.vue";
import * as util from "@/utilities/util.js";
export default {
  name: "App",
  components: { pageLogo, ThemeToggle },
  data() {
    return {
      pageLogo,
      currentTheme: 'light',
      sidebarState: false,
      isConnected: false,
      account: '',
      isAdmin: false,
      isManager: false,
      isTreasury: false,
      
    };
  },
  created() {
    this.currentTheme = localStorage.getItem('theme') || 'light';
    window.addEventListener('storage', this.handleThemeChange);
    this.checkConnection();
  },
  beforeDestroy() {
    window.removeEventListener('storage', this.handleThemeChange);
  },
  async mounted(){
    this.$watch(
      () => {
        return this.$store.state.isConnected;
      },
      (val) => {
        this.isConnected = val;
      }
    );

    await util.reconnect();
    this.$store.commit("changeConnectionStatus", true);
    this.account = await util.getCoinbase();
    this.$store.commit("changeAccount", this.account);
    
    // Check if user has admin role and manager role
    if (this.account) {
      try {
        // Asegurarse de que window.myWeb3 esté disponible
        if (!window.myWeb3 || !window.myWeb3.eth) {
          console.log('Web3 not initialized, skipping role checks');
          return;
        }
        
        // Check admin role
        const nftContract = new window.myWeb3.eth.Contract(util.CMTYNFT_ABI, util.NFT_ContractAddress);
        const ADMIN_ROLE = await nftContract.methods.ADMIN_ROLE().call();
        this.isAdmin = await nftContract.methods.hasRole(ADMIN_ROLE, this.account).call();
        console.log('Is admin:', this.isAdmin);
        
        // Check manager role for vault
        try {
          // Usar el valor constante de MANAGER_ROLE (keccak256('MANAGER_ROLE'))
          const MANAGER_ROLE = '0x241ecf16d79d0f8dbfb92cbc07fe17840425976cf0667f022fe9877caa831b08';
          
          // Verificar si el usuario tiene el rol de manager en el contrato CMTYVault
          // Primero intentamos usar el ABI de AccessControl directamente
          const accessControlABI = [
            {
              "inputs": [
                {
                  "internalType": "bytes32",
                  "name": "role",
                  "type": "bytes32"
                },
                {
                  "internalType": "address",
                  "name": "account",
                  "type": "address"
                }
              ],
              "name": "hasRole",
              "outputs": [
                {
                  "internalType": "bool",
                  "name": "",
                  "type": "bool"
                }
              ],
              "stateMutability": "view",
              "type": "function"
            }
          ];
          
          // const vaultContract = new window.myWeb3.eth.Contract(accessControlABI, util.CMTYv_TokenContractAddress);
          // this.isManager = await vaultContract.methods.hasRole(MANAGER_ROLE, this.account).call();
          // console.log('Is manager:', this.isManager);
          
        } catch (vaultError) {
          console.error('Error checking manager role:', vaultError);
          this.isManager = false;
        }
      } catch (error) {
        console.error('Error checking roles:', error);
        this.isAdmin = false;
        this.isManager = false;
      }

      // Check if user is the treasury of Orchestrator
      try {
        const orchestratorContract = new window.myWeb3.eth.Contract(util.ORCHESTRATOR_ABI, util.ORCHESTRATOR_ContractAddress);
        const treasuryAddress = await orchestratorContract.methods.treasury().call();
        this.isTreasury = this.account.toLowerCase() === treasuryAddress.toLowerCase();
        console.log('Is treasury:', this.isTreasury);
      } catch (error) {
        console.error('Error checking treasury:', error);
        this.isTreasury = false;
      }
    }
  },  
  methods: {
    activateSideBar() {
      this.sidebarState = !this.sidebarState;
    },
    disconnect() {
      this.$store.commit("changeConnectionStatus", false);
      this.$store.commit("changeAccount", null);
    },
    async connect() {
      await util.reconnect()
      window.location.reload('/')
    },
    handleThemeChange(event) {
      if (event.key === 'theme') {
        this.currentTheme = event.newValue;
      }
    },
    async checkConnection() {
      const accounts = await window.ethereum.request({
        method: "eth_accounts",
      });
      if (accounts.length > 0) {
        this.isConnected = true;
        this.account = accounts[0];
      }
    }
  },
};
</script>

<style scoped>
[data-theme="dark"] .navbar-brand,
[data-theme="dark"] .navbar-brand .navbar-item {
  background-color: var(--navbar-background);
}
</style>
